"use client";
import Tabs from "@/components/primitives/tabs";
import { LEADERBOARD_WINDOW_OPTIONS } from "@/data/leaderboard";
import { useQueryUpdater } from "@/utils/hooks/navigation";
import { BettorLeaderboardOrder, BettorMetricsTimeframe, Sport } from "common";
import { useRouter } from "next-nprogress-bar";
import React from "react";


export interface LeaderboardSearchParams {
  timeframe?: BettorMetricsTimeframe;
  limit?: "10" | "25" | "50" | "100";
  order?: BettorLeaderboardOrder;
  page?: string;
}

export default function LeaderboardFilter({
  searchParams,
}: {
  sport?: Sport;
  searchParams: LeaderboardSearchParams;
}) {
  const router = useRouter();
  const { createQueryParamString } = useQueryUpdater();
  
  return (
    <>
      <Tabs
      variant="pill"
        label="Leaderboard View"
        value={searchParams.timeframe || "last25Games"}
        defaultValue="last25Games"
        onValueChange={(v) => router.replace(createQueryParamString("timeframe", v), {scroll: false})}
        items={LEADERBOARD_WINDOW_OPTIONS}
      />
    </>
  );
}
